import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Text,
  Flex,
  Box,
  AccordionPanel,
  AccordionIcon,
} from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import React from 'react';

import PricingSelectorV2AccordionContent, {
  PricingSelectorV2AccordionContentProps,
} from './components/PricingSelectorV2AccordionContent';

export type AccordionType = {
  title: string;
  icon?: string | null;
  detail?: string | null;
  accordionContent?: PricingSelectorV2AccordionContentProps[] | null;
};

export type PricingSelectorV2AccordionsProps = {
  accordions: AccordionType[];
};

/**
 * [Add the description for what this component does here].
 */
export default function PricingSelectorV2Accordions({
  accordions,
}: PricingSelectorV2AccordionsProps) {
  return (
    <>
      <Accordion size="md" allowMultiple>
        {accordions?.map((accordion, index) => (
          <AccordionItem
            key={index}
            title={accordion?.title}
            border="none"
            marginBottom="2"
            borderRadius="xl"
            overflow="hidden"
          >
            <AccordionButton
              backgroundColor="tints.lightCream"
              paddingX="4"
              paddingY="3"
              sx={{
                // Styles for the chevron icon
                svg: {
                  color: 'tints.uiGrey',
                },
              }}
            >
              <Flex width="100%" justifyContent="space-between" marginRight="2">
                <Flex gap="2">
                  <DynamicIcon icon={accordion?.icon} />
                  <Text fontSize="lg">{accordion?.title}</Text>
                </Flex>
                <Text fontSize="lg">{accordion?.detail}</Text>
              </Flex>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel
              borderBottomRadius="xl"
              paddingX="4"
              paddingTop="3"
              paddingBottom="6"
              backgroundColor="tints.lightCream"
            >
              {accordion?.accordionContent?.map((content, index) => {
                const isLast =
                  index === (accordion?.accordionContent?.length ?? 0) - 1;
                return (
                  <Box key={`accordion-content-${index}`}>
                    <PricingSelectorV2AccordionContent {...content} />
                    {/* Separator */}
                    {!isLast && (
                      <Box as="hr" marginY="6" borderColor="tints.darkCream" />
                    )}
                  </Box>
                );
              })}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
}
